import React, { Fragment } from 'react';
import Score from './Score';
import {
  True,
  False,
  Warning,
  Free,
  Role,
  Disposable,
  AcceptAll,
  Tag,
  Numerical,
  MailboxFull,
  NoReply,
} from './SVG';

const EmailReport = ({ data }) => {
  const newData = {
    full_name: data.full_name || (data.first_name && data.last_name) || '—',
    email: data.email,
    score: data.score,
    sections: [
      {
        title: 'General',
        items: [
          { title: 'Full Name', content: data.full_name || (data.first_name && data.last_name) || '—' },
          { title: 'Gender', content: data.gender },
          { title: 'State', content: data.state },
          { title: 'Reason', content: data.reason },
          { title: 'Domain', content: data.domain },
        ],
      },
      {
        title: 'Attributes',
        items: [
          { title: 'Free', icon: <Free />, content: data.free ? 'Yes' : 'No' },
          { title: 'Role', icon: <Role />, content: data.role ? 'Yes' : 'No' },
          {
            title: 'Disposable',
            icon: <Disposable />,
            content: data.disposable ? 'Yes' : 'No',
          },
          {
            title: 'Accept All',
            icon: <AcceptAll />,
            content: data.accept_all ? 'Yes' : 'No',
          },
          { title: 'Tag', icon: <Tag />, content: data.tag || 'No' },
          {
            title: 'Numerical Characters',
            icon: <Numerical />,
            content: data.email.replace(/[^0-9]/g, '').length.toString(),
          },
          {
            title: 'Mailbox Full',
            icon: <MailboxFull />,
            content: data.mailbox_full ? 'Yes' : 'No',
          },
          {
            title: 'No Reply',
            icon: <NoReply />,
            content: data.no_reply ? 'Yes' : 'No',
          },
        ],
      },
      {
        title: 'Mail Server',
        items: [
          { title: 'SMTP Provider', content: data.smtp_provider || '—' },
          { title: 'MX Record', content: data.mx_record || '—' },
        ],
      },
    ],
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.5' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1rem',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>{newData.full_name}</div>
          <p style={{ color: '#6b7280' }}>{newData.email}</p>
        </div>
        <span
          style={{
            backgroundColor:
              newData.score < 0
                ? 'rgb(84, 158, 231)'
                : newData.score < 1
                ? 'rgb(255, 95, 125)'
                : newData.score < 80
                ? 'rgb(255, 203, 96)'
                : 'rgb(62, 210, 153)',
            borderRadius: '8px',
            padding: '0.5rem 1rem',
            color: '#ffffff',
          }}
        >
          {newData.score || '-'}
        </span>
      </div>
      <div style={{ padding: '2rem 3rem' }}>
        <Score data={newData.score} />
      </div>
      
      <div style={{ padding: '1rem', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
        {newData.sections.map((section, index) => (
          <div key={index} style={{ padding: '1rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
            <h4
              style={{
                marginBottom: '1rem',
                borderBottom: '1px solid #e5e7eb',
                paddingBottom: '4px',
                fontSize: '1.125rem',
                fontWeight: '500',
                color: '#374151',
              }}
            >
              {section.title}
            </h4>
            {section.items.map(({ title, content, icon }) => (
              <Item key={title} title={title} content={content} icon={icon} />
            ))}
          </div>
        ))}
      </div>

    </div>
  );
};

const Item = ({ title, content, icon }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.5rem 0',
    }}
  >
    {/* Title and Icon */}
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {icon && <span style={{ marginRight: '0.5rem', fontSize: '1.25rem', color: '#6b7280' }}>{icon}</span>}
      <p style={{ color: '#6b7280', fontWeight: '500', margin: 0 }}>{title}</p>
    </div>
    {/* Content */}
    <div style={{ display: 'flex', alignItems: 'center', color: '#374151' }}>
      <span style={{ marginRight: '0.25rem', fontSize: '1.25rem' }}>
        {content === 'deliverable' ? <True /> : ''}
        {content === 'undeliverable' ? <False /> : ''}
        {content === 'risky' ? <Warning /> : ''}
        {content === 'unknown' ? <Warning /> : ''}
      </span>
      {title === 'Reason' ? (
        <span
          style={{
            backgroundColor: '#f3f4f6',
            borderRadius: '4px',
            padding: '2px 4px',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            color: '#6b7280',
          }}
        >
          {content.replace(/_/g, ' ')}
        </span>
      ) : (
        <span style={{ textTransform: 'capitalize', fontSize: '1rem', margin: 0 }}>{content}</span>
      )}
    </div>
  </div>
);

export default EmailReport;
